import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "./data";
import { SectionHeading } from "./Services";

export const Faq = () => (
  <section id="faq" className="mx-auto max-w-5xl px-5 py-24 sm:px-8 sm:py-36" data-testid="faq-section">
    <SectionHeading id="faq" overline="Questions, Answered" title="Everything students" accent="ask us." />
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.33, 1, 0.68, 1] }}
    >
      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-[#D4AF37]/15" data-testid={`faq-item-${i}`}>
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="py-6 text-left font-serif-display text-xl font-medium text-[#12294D] transition-colors hover:text-[#A07E1F] hover:no-underline sm:text-2xl [&[data-state=open]]:text-[#A07E1F]"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-6 text-sm leading-relaxed text-[#46586F] sm:text-base" data-testid={`faq-content-${i}`}>
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.div>
  </section>
);
